//frontend/src/dropdownMap/1A3a_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    10: "EquipmentReceived",
    11: "ConductedBy",
    15: "Gender",
    17: "PovertyLevel",
    18: "PWDStatus",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    EquipmentReceived: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    ConductedBy: {
        internal: ["npco", "gst", "dafo", "pafo", "wfp", "maf"],
        LA: {
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ",
            "maf": "ກະຊວງ ກປ"
        },
        EN: { "npco": "NPCO", "gst": "GST", "dafo": "DAFO", "pafo": "PAFO", "wfp": "WFP", "maf": "MAF" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
